import React from 'react';
import { useNavigate } from 'react-router-dom';
// Direct submodule import: the design-system barrel transitively pulls the
// auth stack (PageSidebar → logincontext → keycloak-js), which this small
// CTA must not depend on.
import { Button } from '../../../design-system/button';

type Props = {
  projectUid: string | null;
};

/**
 * Post-save call to action: hand the Multi Analysis sample set straight to
 * the Auto Correlation wizard on the Correlation page. The wizard auto-opens
 * (`auto=1`) with the Multi Analysis scope preselected.
 */
const AutoCorrelationCta = ({ projectUid }: Props) => {
  const navigate = useNavigate();

  if (!projectUid) return null;

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        padding: '0.5rem 1rem'
      }}
    >
      <Button
        variant="secondary"
        size="sm"
        data-testid="auto-correlation-cta"
        onClick={() =>
          navigate(
            `/correlation?project=${projectUid}&auto=1&scope=multi_analysis`
          )
        }
      >
        Run Auto Correlation with these samples
      </Button>
    </div>
  );
};

export default AutoCorrelationCta;
